import React from "react";

export const ThankYou = () => {
  return (
    <div className="min-h-screen flex items-center justify-center text-center px-4">
      <div>
        <h1 className="text-4xl font-bold mb-4">Thank you 🎉</h1>
        <p className="text-lg text-gray-600">
          Your message has been sent successfully.
          <br />
          We’ll get back to you shortly.
        </p>
      </div>
    </div>
  );
};
